// src/components/EmployeeRightsPage.js
import React from 'react';
import '../css/EmployeeRightsPage.css'; // стили сделаем тоже

const EmployeeRightsPage = () => {
  return (
    <div className="employee-rights-page">
      <h1>Employee Rights in Saudi Arabia</h1>
      <ul className="rights-list">
        <li>
          <strong>You cannot be forced to leave the country immediately.</strong><br />
          You have at least 60 days.
        </li>
        <li>
          <strong>You are not obligated to leave Saudi Arabia until all financial settlements are completed.</strong><br />
          It will be more difficult to pursue any promised payments after you leave.  
          There have been reports of KAUST changing terms and paying less once a person had already left.
        </li>
        <li>
          <strong>You can hire a lawyer without being physically present in Saudi Arabia.</strong><br />
          One of the law firms you can contact is Dr. Mohammed Almuhanna & Partners.
        </li>
        <li>
          <strong>We recommend contacting your country’s embassy.</strong><br />
          Embassy representatives can call KAUST or submit a protest note to the Ministry of Saudi Arabia.
        </li>
      </ul>
    </div>
  );
};

export default EmployeeRightsPage;
